

export const content = {
  app: {
    description: 'Un portail d’informations sur les films et les séries TV',
    title: 'Dollygrip',
  },
  castAndCrew: {
    subTitles: {
      CREATOR: 'Créé par',
      DIRECTOR: 'Réalisé par',
      EXECUTIVE_PRODUCER: 'Produit exécutif par',
      GUEST_STAR: 'Avec la participation de',
      NOVEL: 'Roman',
      PRODUCER: 'Produit par',
      SCREENPLAY: 'Scénario',
      STAR: 'Avec',
      WRITER: 'Écrit par',
    },
  },
  categories: {
    continueWatching: 'Continuer à regarder',
    favorites: 'Favoris',
    recentlyWatched: 'Regardé récemment',
    shortcuts: 'Raccourcis',
    watchlist: 'Ma liste',
  },
  cookieConsent: {
    acceptButton: 'J’accepte',
    content: "**This application uses cookies**\n\nWe use essential cookies to make the app work. We also use additional cookies to analyse site traffic to improve your experience.",
    customiseButton: 'Personnaliser',
  },
  header: {
    closeSearchAriaLabel: 'Fermer la barre de recherche',
    mainMenuAriaLabel: 'Ouvrir le menu des genres à découvrir',
    openSearchAriaLabel: 'Ouvrir la barre de recherche',
    searchAriaLabel: 'Rechercher des films, séries, acteurs et équipes',
    searchPlaceholder: 'Rechercher...',
  },
  homepage: {
    sections: {
      popularAnimatedMovies: 'Films d’animation populaires',
      popularAnimatedTv: 'Séries animées populaires',
      popularMovies: 'Films populaires',
      popularNature: 'Documentaires nature populaires',
      popularTv: 'Séries populaires',
      topRatedAnimatedMovies: 'Meilleurs films d’animation',
      topRatedAnimatedTv: 'Meilleures séries animées',
      topRatedDocs: 'Meilleurs documentaires',
      topRatedMovies: 'Meilleurs films',
      topRatedTv: 'Meilleures séries',
      trending: 'Tendances',
    },
  },
  pages: {
    discover: 'Découvrir',
  },
  reviewsBadge: {
    ariaLabel: 'Afficher les critiques des utilisateurs',
    title: 'Critiques',
  },
  ribbons: {
    movieAndTv: {
      CANCELED: 'Annulé',
      ENDED: 'Terminé',
      IN_PRODUCTION: 'En prod',
      PLANNED: 'Prévu',
      POST_PRODUCTION: 'Post-prod',
      RETURNING_SERIES: 'De retour',
      RUMORED: 'Rumeur',
    },
    season: {
      airingNow: 'En cours',
      airs: 'Diffus',
    },
  },
  screenTypes: {
    MOVIE: 'Film',
    TV: 'Série TV',
  },
  theMovieDb: {
    disclaimer:
      'Cette application utilise TMDB et les APIs de TMDB, mais n’est ni approuvée, certifiée, ni autrement validée par TMDB.',
  },
  watchlist: {
    UPCOMING: {
      fallbackContent: "##### Keep on top of upcoming movies and tv shows by adding them to your watchlist\n\nJust select the <AlarmOff /> icon next to the movie or TV show you'd like to keep track of. On tiles, you can add to your watchlist by selecting the <MoreVert /> icon in the top right corner.",
    },
    airDates: {
      CANCELED: {
        fallback: 'Date de dernière diffusion inconnue',
        withDate: 'Dernière diffusion',
      },
      IN_PRODUCTION: 'Prévu pour',
      PILOT: {
        fallback: 'Date du prochain épisode inconnue',
        withDate: 'Prochain épisode',
      },
      PLANNED: 'Prévu pour',
      RETURNING_SERIES: {
        fallback: 'Date du prochain épisode inconnue',
        withDate: 'Prochain épisode',
      },
    },
    categories: {
      CANCELED: 'Annulé',
      COMPLETED: 'Sorti',
      IN_PRODUCTION: 'Tournage',
      PLANNED: 'Prévu',
      UPCOMING: 'À venir',
    },
    movieReleaseDateFallback: 'Pas de date de sortie',
    releaseDates: {
      CANCELED: 'Était prévu pour',
      IN_PRODUCTION: 'Prévu pour',
      PLANNED: 'Prévu pour',
      POST_PRODUCTION: 'Sortie prévue',
      RELEASED: 'Sorti',
      RUMORED: 'Prévu pour',
      present: 'Aujourd’hui',
    },
    tablist: {
      ariaLabel: 'Catégories de ma liste',
    },
    tvAirDateFallback: 'Pas de date de diffusion',
  },
  watchlistBadge: {
    addAriaLabel: 'Ajouter à la liste de suivi',
    removeAriaLabel: 'Retirer de la liste de suivi',
  },
} as const;
